"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _uiKit = require("@icis/ui-kit");
var _Nav = require("./Nav.style");
var _mapIconKeyToUiKit = _interopRequireDefault(require("../../../../../../utils/mapIconKeyToUiKit"));
const FooterNav = _ref => {
  let {
    announcementsRead,
    items,
    selectedFooterSection,
    onOpenItem,
    unreadAnnouncementsCount
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_Nav.Footer, {
    "data-test-id": "res-service-menu"
  }, items.map(_ref2 => {
    let {
      icon
    } = _ref2;
    const newIcon = (0, _mapIconKeyToUiKit.default)(icon);
    const showUnread = newIcon === 'announcements' && !announcementsRead && unreadAnnouncementsCount;
    const active = selectedFooterSection === newIcon;
    return /*#__PURE__*/_react.default.createElement(_Nav.FooterItemWrapper, {
      key: newIcon,
      itemCount: items.length
    }, /*#__PURE__*/_react.default.createElement(_Nav.NavButton, {
      active: active,
      onClick: () => onOpenItem(newIcon),
      "data-test-id": "res-service-menu-".concat(newIcon)
    }, !!showUnread && /*#__PURE__*/_react.default.createElement(_Nav.UnreadIndicator, null), /*#__PURE__*/_react.default.createElement(_uiKit.Icon, {
      icon: newIcon,
      color: active ? _uiKit.theme.colours.PRIMARY_1 : _uiKit.theme.colours.WHITE,
      size: "lg"
    })));
  }));
};
var _default = exports.default = FooterNav;